module.exports = __webpack_public_path__ + "img/pic-FannyZhang.97fdcc98.png";